<div class="file-name-area file-error" *ngIf="!!message?.length">
  <div>
    <div *ngIf="!hideFileName" class="file-name-text">{{ fileName }}</div>
    <div [class.fullWidthN1]="hideFileName">{{ message }}</div>
  </div>
</div>
